import installation from './images/installation.png';
import maintenance from './images/maintenance.png';
import consultation from './images/consultation.png';

const serviceData = [
  {
    id: 1,
    name: 'Installation',
    Image: installation
  },
  {
    id: 2,
    name: 'Maintenance',
    Image: maintenance
  },
  {
    id: 3,
    name: 'Consultation',
    Image: consultation
  }
];

export default serviceData;
